(function () {

    const elements = document.querySelectorAll('.mod24ac.date .widget');

    for (let i = 0; i < elements.length; i++) {
        $(elements[i]).c24TeaserDateWidget();
    }


})();
